module.exports = __webpack_public_path__ + "static/media/ysjwechat@2x.a5466bb3.png";